import React from "react";
import {
  GridFilterForm,
  GridPanelWrapper,
  gridFilterModelSelector,
  gridFilterableColumnDefinitionsSelector,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from "@mui/x-data-grid-pro";

import { FILTER_PANEL_PROPS, FilterPanelBody, type FilterPanelSlotProps } from "./datagrid/filterPanel";

/**
 * A Pro 6.9 grid's Filters panel (`slots.filterPanel`): THE panel, Figma Component 73
 * (datagrid/filterPanel.tsx), fed from this grid's own context. What the grid passes the slot
 * (its `slotProps.filterPanel`, e.g. `statusFilter`) applies on top of the shared defaults.
 * AeronetDataGrid and Inventory Demand's grid set it; a raw `DataGridPro` sets it itself.
 */
const CustomFilterPanel = React.forwardRef<HTMLDivElement, FilterPanelSlotProps>(function CustomFilterPanel(props, ref) {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const model = useGridSelector(apiRef, gridFilterModelSelector);
  const filterableColumns = useGridSelector(apiRef, gridFilterableColumnDefinitionsSelector);
  return (
    <FilterPanelBody
      ref={ref}
      {...FILTER_PANEL_PROPS}
      {...props}
      grid={{
        apiRef,
        model,
        filterableColumns,
        multipleColumns: !rootProps.disableMultipleColumnsFiltering,
        FilterForm: GridFilterForm,
        PanelWrapper: GridPanelWrapper,
      }}
    />
  );
});

export default CustomFilterPanel;
